import SORT_ORDER from 'src/enums/sortOrder';
import useFetchReducer from 'src/hooks/useFetchReducer';
import { FetchState } from 'src/reducers/fetchReducer';
import { ColumnSorting } from '../modals/AuditModal/AuditList/AuditTable/AuditTable.config';
import { getAuditList } from '../api/scriptConfiguration.api';
import { AuditList, AuditItem } from '../types/scriptConfiguration';

export type QaErrorsListState = FetchState<AuditItem[]>;

type UseQaErrorsListFetchParams = {
  scriptErrorConfigId: string | null;
  columnName: string;
  sorting: ColumnSorting;
};

const initialState: QaErrorsListState = {
  loading: false,
  error: false,
  data: null,
};

const useAuditListFetch = ({
  scriptErrorConfigId,
  columnName,
  sorting,
}: UseQaErrorsListFetchParams): [QaErrorsListState, () => void] => {
  const params: AuditList.Request = {
    scriptErrorConfigId: scriptErrorConfigId,
    columnName: columnName,
    sortingOrder: SORT_ORDER[sorting.order],
    sortingColumn: sorting.field,
  };

  const [{ loading, data, error }, refetch] = useFetchReducer(() => getAuditList(params), Object.values(params));

  const state: QaErrorsListState = { ...initialState, loading, error };

  if (data === null) {
    return [state, refetch];
  }

  return [
    {
      ...state,
      data: data.auditList,
    },
    refetch,
  ];
};

export default useAuditListFetch;
